"use strict";
var $ = require("../internals/export");
var globalThis = require("../internals/global-this");
var setToStringTag = require("../internals/set-to-string-tag");
$({ global: true }, { Reflect: {} });
setToStringTag(globalThis.Reflect, "Reflect", true);
